import clsx from 'clsx'
import { HTMLAttributes } from 'react'
import styles from './HoverableText.module.css'

export interface HoverableTextProps extends HTMLAttributes<HTMLDivElement> {}

export default function HoverableText({ className, ...props }: HoverableTextProps) {
	return <span {...props} className={clsx(styles.root, className)} />
}
